import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  standalone: false
})
export class CardComponent implements OnInit {
  @Input() cardTitle: string;
  @Input() cardClass: string;
  @Input() blockClass: string;
  @Input() headerClass: string;
  @Input() options = true;
  @Input() hidHeader = false;
  @Input() isCardFooter = false;
  @Input() footerClass: string;

  constructor() { }

  ngOnInit() {
    if (!this.options || this.hidHeader || !this.cardTitle) {
      this.options = false;
    }
  }
}
